import React, { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import parse, { attributesToProps } from 'html-react-parser';
import styled, { createGlobalStyle } from 'styled-components';

import { CmsContext } from 'helpers/providers/contexts';

const ChangeableButtonBg = ({ id, defaultColor, children, buttonContainerCss }) => {
  const content = useContext(CmsContext);
  const [bgColor, setBgColor] = useState(defaultColor);

  const targetString = content?.[id]?.children || '';
  const cssVar = useMemo(() => ({ name: id, value: bgColor }), [bgColor]);

  const handleReplaceNode = (node) => {
    const props = attributesToProps(node.attribs);
    if (props.style.background !== bgColor) {
      setBgColor(props.style.background);
      return;
    }

    return <div {...props} />;
  };

  return (
    <ButtonContainer cssVar={cssVar} buttonContainerCss={buttonContainerCss}>
      <GlobalStyle cssVar={cssVar} />
      <div data-editable='true' data-name={id}>
        {targetString ? (
          parse(targetString, {
            replace: handleReplaceNode,
          })
        ) : (
          <div data-ce-tag='bkgimg' style={{ background: defaultColor }} />
        )}
      </div>
      {children}
    </ButtonContainer>
  );
};

const GlobalStyle = createGlobalStyle`
  :root {
    ${({ cssVar }) => cssVar.value && `
      --${cssVar.name}-color: ${cssVar.value};
    `}
  }
`;

const ButtonContainer = styled.div`
  position: relative;
  display: inline-flex;

  & button,
  & a {
    ${({ cssVar }) => cssVar.value && `
      background: var(--${cssVar.name}-color);
    `}
  }

  ${({ buttonContainerCss }) => buttonContainerCss};
`;

ChangeableButtonBg.propTypes = {
  id: PropTypes.string.isRequired,
  defaultColor: PropTypes.string.isRequired,
  children: PropTypes.node,
  buttonContainerCss: PropTypes.array,
};

export default ChangeableButtonBg;
